var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddvideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95,
    height: 76,
    viewBox: "0 0 95 76",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 76C6.8875 76 4.65183 75.0706 2.793 73.2118C0.931 71.3498 0 69.1125 0 66.5V9.5C0 6.8875 0.931 4.65183 2.793 2.793C4.65183 0.930999 6.8875 0 9.5 0H66.5C69.1125 0 71.3498 0.930999 73.2118 2.793C75.0706 4.65183 76 6.8875 76 9.5V30.875L90.9625 15.9125C91.675 15.2 92.5268 15.0211 93.518 15.3757C94.506 15.7336 95 16.4667 95 17.575V58.425C95 59.5333 94.506 60.2648 93.518 60.6195C92.5268 60.9773 91.675 60.8 90.9625 60.0875L76 45.125V66.5C76 69.1125 75.0706 71.3498 73.2118 73.2118C71.3498 75.0706 69.1125 76 66.5 76H9.5ZM19.1187 57H56.8813C57.9104 57 58.6435 56.5646 59.0805 55.6938C59.5143 54.8229 59.4146 53.9917 58.7812 53.2L47.2625 38.1187C46.7875 37.4854 46.1542 37.1688 45.3625 37.1688C44.5708 37.1688 43.9375 37.4854 43.4625 38.1187L34.4375 49.875L28.975 42.75C28.5 42.1167 27.8667 41.8 27.075 41.8C26.2833 41.8 25.65 42.1167 25.175 42.75L17.2188 53.2C16.5854 53.9917 16.4857 54.8229 16.9195 55.6938C17.3565 56.5646 18.0896 57 19.1187 57Z",
    fill: "#9B9B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddvideoIcon);
export default __webpack_public_path__ + "static/media/AddvideoIcon.87be5bfb.svg";
export { ForwardRef as ReactComponent };